 /* eslint-disable */
import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const menuService = {
    getMenuData,
    getAllMenuTree,
    getRolesMenuTree,
    addRolesMenuTree
};

async function getMenuData() {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify({ actionCode: 33 })
    };
    return await fetch(`${config.API_URL}/Menu/GetMenuTree`, requestOptions)
        .then(response => common.handleResponse(response))
        .then(res => {
            if (!res.data) {
                return { code: false, data: res };
            }
            else {
                // Lưu dữ liệu menu vào local storage
                localStorage.setItem('menu', JSON.stringify(res.data));
                return { code: true, data: res.data };
            }
        });;
}

async function getAllMenuTree() {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        //body: JSON.stringify({ actionCode: 33 })
    };
    return await fetch(`${config.LOGIN_URL}/Menu/GetAllMenuTree`, requestOptions)
        .then(response => common.handleResponse(response));
}

async function getRolesMenuTree(params) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/RolesMenu/GetMenuTree`, requestOptions)
        .then(response => common.handleResponse(response));
}

async function addRolesMenuTree(params) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/RolesMenu/AddRoleMenu`, requestOptions)
        .then(response => common.handleResponse(response));
}

